exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rangos[data-v-c576019e] {\r\n  text-align: center;\r\n  font-weight: 500;\r\n  margin-bottom: 10px;\r\n  font-size: 14px;\r\n  color: #ccd1d9;\n}\n.rangos > small[data-v-c576019e] {\r\n  font-size: 12px;\r\n  color: #aab2bd;\n}\n.rangos > span[data-v-c576019e] {\r\n  color: #656d78;\n}\r\n", ""]);

// exports
